module.exports = __webpack_public_path__ + "img/5.757d4c39.jpeg";